<template>
  <div class="mx-auto pa-0" v-if="lastMomentSecurity">
    <v-layout row wrap class="cm-header position-relative">
      <v-flex xs12 md7 lg7 class="d-flex justify-center">
      </v-flex>

      <v-flex xs12 md5 lg5 class="image-background d-flex align-center justify-center">
        <v-img :src="lastMomentSecurity.main_image" alt="Imagen del Momento Security" class="header-image"></v-img>
      </v-flex>

      <!-- Contenido superpuesto -->
      <div class="overlay-content">
        <div class="overlay-text">
          <h3 class="cm-title text-blue-v2" style="margin-bottom: .5rem">Nuestros Momentos</h3>
          <h3 class="cm-subtitle text-blue-v2">{{ lastMomentSecurity.title }}</h3>
          <p class="py-3 text-18-security mb-4">{{ lastMomentSecurity.content }}</p>
          <v-btn class="cm-btn-bg-white" @click="goToMoment(lastMomentSecurity.slug)">
            Ir a la noticia
          </v-btn>
          <a class="cm-btn-secondary" @click="goToMoments">Ver más Momentos</a>
        </div>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("posts", ["lastMomentSecurity"]),
  },
  methods: {
    goToMoment(slug) {
      this.$router.push(`/noticias/${slug}`);
    },
    goToMoments() {
      this.$router.push('/momentos');
    },
  },
  created() {
    const viewAs = localStorage.getItem("view_as");
    this.$store.dispatch('posts/fetchLastMomentSecurity', viewAs);  },
};
</script>


<style scoped>
h1, h2{ 
  font-weight: 400;
}
.content-overlay{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 100%; */
}
.cm-container-report-channel{
  margin: auto;
  min-height: 420px;
}
img{
  width: 100%;
  object-fit: cover;
  height: 420px;
}
.cm-btn-bg-blue{
  font-size: 16px
}
.text-center{
  width: 50%;
}
@media (max-width: 1440px) {
    .w-100 {
      padding: 0px 0px 0px 0px;
    }
  }
@media (max-width: 600px) {
  .image-container {
    display: none ;
  }
  .cm-container{
    padding: 5%;
  }
  .text-center{
    text-align: center;
  }
  .cm-container{
    height: auto;
  }
}
@media (min-width: 1500px) {
  .w-100 {
    max-width: 1440px;
  }
}
</style>
